import { useCallback, useState } from 'react';

export type Action = ((...arg: any[]) => Promise<any> | any) | string;
export type IsLoading = (...functions: (Action | string)[]) => boolean;

export interface Loaders {
  addLoader: (action: Action) => void;
  removeLoader: (action: Action) => void;
  isLoading: IsLoading;
  loaders: Record<string, boolean>;
}

export function useLoaders(initialState: Record<string, boolean> = {}): Loaders {
  const [loaders, setLoaders] = useState<Record<string, boolean>>(initialState);

  const addLoader = useCallback((action: Action) => {
    setLoaders(prev => ({ ...prev, [getActionName(action)]: true }));
  }, []);
  const removeLoader = useCallback(
    (action: Action) => setLoaders(prev => ({ ...prev, [getActionName(action)]: false })),
    [],
  );

  const isLoading: IsLoading = useCallback(
    (action: Action) => !!loaders[getActionName(action)],
    [loaders],
  );

  return { addLoader, removeLoader, isLoading, loaders };
}

const getActionName = (action: Action) => (typeof action === 'string' ? action : action.name);
